import * as React from "react";

function SvgNext(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      width="1em"
      viewBox="0 0 16 16"
      className="next_svg__Svg-ulyrgf-0 next_svg__hJgLcF"
      {...props}
    >
      <path d="M11 3v4.119L3 2.5v11l8-4.619V13h2V3z" />
    </svg>
  );
}

export default SvgNext;
